// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tab-container_tabContainer_2X00Z","operation":"tab-container_operation_1O8xJ"};